@if (projectDetails(); as project) {
  <div class="info-grid card">
    <div class="info-item">
      <div class="icon fas fa-percentage"></div>
      <div class="label">
        {{ "projectDetails.features.interestRate" | translate }}
      </div>
      <div class="value">
        {{ project.interestMin }}% – {{ project.interestMax }}%
      </div>
    </div>

    <div class="info-item">
      <div class="icon fas fa-cogs"></div>
      <div class="label">
        {{ "projectDetails.features.yield" | translate }}
      </div>
      <div class="value">{{ project.yieldMin }}% – {{ project.yieldMax }}%</div>
    </div>

    <div class="info-item">
      <div class="icon fas fa-hourglass-half"></div>
      <div class="label">{{ "projectDetails.features.term" | translate }}</div>
      <div class="value">
        {{
          project.loanTypePaymentStart | loanTerm: project.loanTypePaymentEnd
        }}
        {{ "projectDetails.features.month" | translate }}
      </div>
    </div>

    <div class="info-item">
      <div class="icon fas fa-calendar-alt"></div>
      <div class="label">
        {{ "projectDetails.features.paymentDate" | translate }}
      </div>
      <div class="value">
        {{ getDateString(project.targetColletionEndDate) }}
      </div>
    </div>
  </div>
}
